import React, { useCallback } from 'react';
import { VbzHeaderPlaceholder, VbzButton } from '@smiles/voebiz-ui-kit';
import { useTranslation, Trans } from 'react-i18next';

import { DefaultMsgPageProps } from './types';

const DefaultMsgPage = ({
  traductionKey = '',
  image,
  traductionContentParams,
  isPrimaryLoading = false,
  onPrimary,
  onSecondary,
  children,
  redirectUrl,
}: DefaultMsgPageProps) => {
  const { t } = useTranslation(traductionKey);

  const renderButton = useCallback(() => {
    if (!onPrimary && !onSecondary) {
      return null;
    }

    return (
      <div className="vbz-components-message-container-buttons">
        {onPrimary && (
          <VbzButton
            text={t('btn_primary')}
            onClick={onPrimary}
            isLoading={isPrimaryLoading}
            animation={isPrimaryLoading}
          />
        )}
        {onSecondary && <VbzButton text={t('btn_secondary')} onClick={onSecondary} color="hyperlink" />}
      </div>
    );
  }, [onPrimary, onSecondary, t, traductionKey, isPrimaryLoading]);

  const renderSub = useCallback(() => {
    const traduction = t('content_sub');
    if (traduction === 'content_sub') {
      return null;
    }

    return <p>{traduction}</p>;
  }, [t, traductionKey]);

  const getClassIcon = useCallback(() => {
    switch (image) {
      case 'beachChair':
        return 'vbz-icon-beach_chair';
      case 'brokenSuitcase':
        return 'vbz-icon-broken_suitcase';
      case 'cellPhone':
        return 'vbz-icon-cell_phone';
      case 'email':
        return 'vbz-icon-email';
      case 'profile':
        return 'vbz-icon-profile';
      default:
        return '';
    }
  }, [image]);

  return (
    <div className="vbz-components-message">
      <VbzHeaderPlaceholder redirectUrl={redirectUrl !== undefined ? redirectUrl : window.location.origin} />
      <div className="vbz-components-message-container">
        <div>
          <div className={`image ${getClassIcon()}`} />
          <div className="vbz-components-message-container-content">
            <h3>{t('header')}</h3>
            <p>
              <Trans t={t} i18nKey="content" values={traductionContentParams} components={{ bold: <b /> }} />
            </p>
            {renderSub()}
            {renderButton()}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DefaultMsgPage;
